module.exports = __webpack_public_path__ + "static/media/fileDOC.06a61fa4.svg";